import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { CompanySite } from 'src/app/admin-dashboard/company-sites/company-sites.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-card-view-layout',
  templateUrl: './card-view-layout.component.html',
  styleUrls: ['./card-view-layout.component.css']
})
export class CardViewLayoutComponent implements OnInit, OnDestroy {

  @Input() title: string;
  @Input() showAdd: boolean = true;
  @Input() showEdit: boolean;
  @Input() showDelete: boolean;
  @Input() sort: boolean = true;
  @Input() showListSelect: boolean;

  @Input() useSystems: boolean = false;
  @Output() onAdd = new EventEmitter<boolean>();
  @Input() data: Observable<any>;
  @Input() actionButtons;
  @Output() onDelete = new EventEmitter<Object>();
  @Output() onUpdate = new EventEmitter<Object>();
  dataSub: Subscription;
  currentView = 'CARD';
  result;
  @Input() defaultLink: string;
  constructor() {
  }

  ngOnInit() {


    if (this.sort)
      this.data = this.data.pipe(map(dataArray => dataArray.sort(
        (a, b) => {
          if (a.name < b.name)
            return -1;
          if (a.name > b.name)
            return 1;
          return 0;
        }
      )))

    if (this.data)
      this.dataSub = this.data.subscribe(d => {
        this.result = d
      })
  }

  add(event) {
    this.onAdd.emit(event);
  }

  // _changeView(event){
  //   this.changeView.emit(event);
  // }

  cardViewClick() {
    // localStorage.setItem('currentView', 'CARD');
    this.currentView = 'CARD'//localStorage.getItem('currentView')

  }
  listViewClick() {

    // localStorage.setItem('currentView', 'LIST');
    this.currentView = 'LIST'//localStorage.getItem('currentView')
  }

  ngOnDestroy(): void {
    if (this.dataSub)
      this.dataSub.unsubscribe();
  }


  onDeleteSite(uid, $event) {
    this.onDelete.emit({ uid, $event })
  }

  onUpdateSite(uid, $event) {
    this.onUpdate.emit({ uid, $event })
  }
}
